import global from '../patterns/global-variables';
import $ from 'jquery';
window.jQuery = $;
import modal from '../patterns/modal.js';
import utils from '../patterns/utils';
import PL_utils from '../patterns/pl-utils.js';

const body = document.querySelector('body');

const logout = function () {
    return utils.logoutSession()
    .done(function (resp) {
        if (global.AUTHENTICATED_PAGES.indexOf(location.pathname) > -1) {
            window.location.href = '/';
        } else {
            window.location.reload(true);
        }
    })
    .fail(function (err) {
        console.error(JSON.stringify(err));
    });
};

// ModalHooks shared by modal exit and modal exit-alt
const modalHooks = {
    _hasScrolledToBottom: false,
    _addModalError: function (target) { },
    _removeModalError: function (target) { },
    beforeOpen: function (target) {
        PL_utils.addClass('modal-open', body);
    },
    afterOpen: function (target) { },
    onContinue: function (e, target) {
        logout();
    },
    onCancel: function () {
        return false;
    },
    beforeClose: function () {
        document.querySelectorAll('.modal').forEach((item) => {
            if (!item.getAttribute("hidden")) {
                item.setAttribute('hidden', "");
                item.setAttribute("aria-hidden", true);
            }
        });
        return false;
    },
    afterClose: function () {
        PL_utils.removeClass('modal-open', body);
        const modalTrigger = document.querySelector('.logout');
        modalTrigger.focus();
    },
    setSize: function () {
        return false;
    },
    onScreenshot: function () {
        return false;
    },
    onInit: function (target) {

    }
};

const modalOpts = {
    enableBackdropClose: true
};

const showErrorModal = (modalID) => {
    const errorModal = modal.initModal(document.querySelector(modalID), modalHooks, modalOpts);
    errorModal.showModal();
};

export default () => {
    if (utils.getParam('modal') == 'logout') {
        showErrorModal('.modal-logout');
    }

    const logoutBtn = document.querySelector('.logout');

    if (logoutBtn) {
        logoutBtn.addEventListener('click', function() { showErrorModal('.modal-logout') })
    }

    //Check login state every minute and on page load

    const csrfTokenCheck = (csrfToken) => {
        $.ajax(global.API_ENDPOINT() + '/location/list', {
            dataType: 'json',
            method: 'GET',
            headers: {
                'csrf-token': csrfToken,
            },
            xhrFields: {
                withCredentials: true,
            }
        })
        .done(function (resp) {
            if (!resp.success && (resp.data.errorCode == "E001" || resp.data.errorCode == "E002")) {
                logout();
            }
        })
        .fail(function (err) {
            console.error(JSON.stringify(err));
        })
    }

    const csrfToken = utils.getCookie('csrfToken');

    if (csrfToken) {
        window.addEventListener('load', csrfTokenCheck(csrfToken));
        setInterval(csrfTokenCheck(csrfToken), 60000);
    }
}

